// src/components/LandingPage/Footer.tsx
export default function Footer() {
  const columns = [
    { heading: "About", links: ["Our Story", "Team", "Careers"] },
    { heading: "Resources", links: ["Documentation", "Tutorials", "Support"] },
    { heading: "Community", links: ["Events", "Blog", "Forum"] },
    { heading: "Connect", links: ["Twitter", "LinkedIn", "GitHub"] },
  ];

  return (
    <footer
      className="py-10 lg:py-16"
      style={{ backgroundImage: "linear-gradient(166.102deg, rgb(0,88,171) 0%, rgb(29,54,90) 100%)" }}
    >
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 lg:mb-12">
          {columns.map((col) => (
            <div key={col.heading}>
              <h3 className="text-sm lg:text-[18px] font-medium text-white mb-3 lg:mb-4">{col.heading}</h3>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#" className="text-xs lg:text-sm text-[rgba(255,255,255,0.8)] hover:text-white transition-colors">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[rgba(255,255,255,0.2)] pt-6 lg:pt-8">
          <p className="text-xs lg:text-sm text-[rgba(255,255,255,0.6)] text-center">© 2026 Capgemini. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
